// User-supplied NECS illustrations, used only by the commercial services views.
export const COMMERCIAL_SERVICE_SLIDES = [
  {
    title: 'Janitorial Cleaning',
    image: '/images/commercial-services/commercial-cleaning.webp',
    alt: 'NECS crew polishing floors and cleaning surfaces in a commercial lobby',
  },
  {
    title: 'Pressure Washing',
    image: '/images/commercial-services/pressure-washing.webp',
    alt: 'NECS crew pressure washing a retail storefront walkway',
  },
  {
    title: 'Exterior Floor Scrubbing & Polishing',
    image: '/images/commercial-services/gas-station-cleaning.webp',
    alt: 'NECS crew cleaning a gas station forecourt and convenience-store entrance',
  },
  {
    title: 'Window Cleaning',
    image: '/images/commercial-services/window-cleaning.webp',
    alt: 'NECS crew washing exterior windows at a university',
  },
  {
    title: 'Cleaning & Sanitizing',
    image: '/images/commercial-services/medical-cleaning.webp',
    alt: 'NECS cleaner disinfecting surfaces in a medical patient room',
  },
  {
    title: 'Bulk Removal',
    image: '/images/commercial-services/bulk-removal.webp',
    alt: 'NECS crew removing furniture and loading a bulk-removal truck at a warehouse',
  },
  {
    title: 'Deep Cleaning',
    image: '/images/commercial-services/restaurant-cleaning.webp',
    alt: 'NECS crew cleaning restaurant floors, dining furniture and windows',
  },
  {
    title: 'Carpet Cleaning',
    image: '/images/commercial-services/carpet-cleaning.webp',
    alt: 'NECS crew extracting and cleaning carpet in an airport terminal',
  },
].map(slide => ({ ...slide, objectFit: 'contain' }));